import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Table, TableCell, TableCellDropdown, Dropdown, Icon, Tooltip } from '@weezevent/nacre';
import { InfoTextTooltip } from '../../../../attendee/detail/components/infotext-tooltip/infoTextTooltip';
import { useTranslation } from 'react-i18next';
import { typesKeyNames } from '../helper';
import moment from 'moment-timezone';
import Style from './templateRow.module.css';

export const RowDate = React.memo(({ date, organization }) => {
    if (!date) {
        return '-';
    }
    const dateObject = new Date(date);
    //@Todo useless ?
    const tzDate = moment(dateObject).tz(organization.timezone, true);

    const formatter_date = new Intl.DateTimeFormat(organization.default_language, { dateStyle: 'short' });
    const formatted_date = formatter_date.format(tzDate);
    const formatter_time = new Intl.DateTimeFormat(organization.default_language, { timeStyle: 'short' });
    const formatted_time = formatter_time.format(tzDate);

    return <InfoTextTooltip title={formatted_date} subtitle={formatted_time} />;
});

export const TemplateRow = React.memo(({ template, organization = {}, selectedTemplates = {}, onSelected = () => {}, setModaleType = () => {} }) => {
    const { t } = useTranslation();
    const prefix = React.useMemo(() => {
        return `/ticket/O${organization.id}/tickets_design/templates`;
    }, [organization]);
    const history = useHistory();

    return (
        <Table.Tr
            active={Boolean(selectedTemplates[template.pk])}
            onSelected={(event, data) => onSelected({ event, data }, template)}
            onClick={() => history.push(`${prefix}/${template.pk}`)}
        >
            <Table.Td>
                <RowDate date={template.created} organization={organization} />
            </Table.Td>
            <Table.Td>{template.name}</Table.Td>
            <Table.Td>{t(`ticket.ticket_design.type.${typesKeyNames[template.type]}`)}</Table.Td>
            <TableCell style={{ paddingLeft: 0 }} className={Style['icon-action-cell']}>
                <Tooltip margin={false} triggerOnHover title={t('ticket.ticket_design.templates.linked_designs')} visible>
                    <Icon name="list" margin={false} onClick={() => setModaleType({ action: 'preview', selected: [template] })} />
                </Tooltip>
            </TableCell>
            <TableCellDropdown className={Style['dropdown-action-cell']}>
                <Dropdown.Item onClick={() => history.push(`${prefix}/${template.pk}`)}>{t('ticket.common.action.edit')}</Dropdown.Item>
                <Dropdown.Item onClick={() => setModaleType({ action: 'duplicate', selected: [template] })}>{t('ticket.common.action.duplicate')}</Dropdown.Item>
                <Dropdown.Item onClick={() => setModaleType({ action: 'preview', selected: [template] })}>{t('ticket.ticket_design.templates.modale.preview')}</Dropdown.Item>
                <Dropdown.Line />
                <Dropdown.Item onClick={() => setModaleType({ action: 'delete', selected: [template] })} deleteItem>
                    {t('ticket.common.action.delete')}
                </Dropdown.Item>
            </TableCellDropdown>
        </Table.Tr>
    );
});

TemplateRow.propTypes = {
    template: PropTypes.object.isRequired,
    selectedTemplates: PropTypes.object,
    organization: PropTypes.object,
    onSelected: PropTypes.func,
    setModaleType: PropTypes.func,
    setActiveTemplate: PropTypes.func
};
